module.exports = __webpack_public_path__ + "img/avatar.d487d09c.jpg";